var Marionette = require('marionette')
var MultiselectItemView = require('./items/Multiselect')
var ScaleItemView = require('./items/Scale')

module.exports = Marionette.CollectionView.extend({
  tagName: 'ul',
  childViewOptions: function (model) {
    return {
      itemIndex: this.collection.indexOf(model)
    }
  },
  getChildView: function (child) {
    var itemType = child.get('type')
    if (itemType === 'multiselect') {
      return MultiselectItemView
    } else if (itemType === 'scale') {
      return ScaleItemView
    }
  },
  childEvents: {
    'item:value:changed': function (view, index, value) {
      this.trigger('item:value:changed', index, value)
    }
  }
})
